/**
 * You have unsaved changes. Do you want to leave without saving?
 */
export const WARNING_MESSAGE =
  "Du hast nicht gespeicherte Änderungen, die verloren gehen können. Möchtest du trotzdem fortfahren?";
